"use client";

import {
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuTrigger,
} from "@/components/ui/NavigationMenu";
import { cn } from "@/lib/utils";
import React, { useEffect, useState } from "react";

interface DesktopSubMenuProps {
  title: string;
  children: React.ReactNode;
  className?: string;
}

export const DesktopSubMenu = ({
  children,
  title,
  className,
}: DesktopSubMenuProps) => {
  // initially force mount the component for SEO purposes
  // (client component will be server side rendered and hydrated while being invisible)
  const [initialMount, setInitialMount] = useState<true | undefined>(true);

  useEffect(() => {
    setInitialMount(undefined);
  }, []);

  return (
    <NavigationMenuItem key={title} className="[&>div]:invisible">
      <NavigationMenuTrigger className="main-navigation-menu-trigger">
        {title}
      </NavigationMenuTrigger>
      <NavigationMenuContent className="md:w-full" forceMount={initialMount}>
        <div className={cn("container py-4xl px-lg", className)}>
          <div className="flex gap-3xl xl:gap-5xl">{children}</div>
        </div>
      </NavigationMenuContent>
    </NavigationMenuItem>
  );
};
